<template>
    <div id="install-code-page">
        <AppBreadCrumb></AppBreadCrumb>
        <InstallCode></InstallCode>
    </div>
</template>

<script>
import AppBreadCrumb from "../../components/common/AppBreadCrumb";
import InstallCode from "../../components/fast-initialize/InstallCode";

export default {
    name: "InstallationInstarctionPage",
    components: {
        AppBreadCrumb,
        InstallCode,
    },
};
</script>

<style scoped></style>
